import { Link, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Hexagon } from "lucide-react";

export default function Navbar() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check token in localStorage (or replace with cookie logic)
    const token = localStorage.getItem("text2sql_authToken");
    setIsLoggedIn(!!token && token !== "undefined" && token !== "null");
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("text2sql_authToken");
    localStorage.removeItem("text2sql_user");
    setIsLoggedIn(false);
    // navigate("/login");
    window.location.href = process.env.REACT_APP_BASE_PATH || "/";
  };

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-6 py-6 flex justify-between items-center">

        {/* Brand */}
        <Link to="/" className="flex items-center gap-2 text-2xl font-bold text-blue-700">
          <Hexagon className="w-8 h-8 text-blue-600 fill-blue-600" />
          <span>Uplatz Text2SQL</span>
        </Link>

        {/* Navigation */}
        <nav className="space-x-6 text-gray-600 font-medium flex items-center">

          <NavLink to="/" end
            className={({ isActive }) =>
              isActive ? "text-blue-600" : "hover:text-blue-600"
            }
          >
            Home
          </NavLink>

          <NavLink to="/about-us"
            className={({ isActive }) =>
              isActive ? "text-blue-600" : "hover:text-blue-600"
            }
          >
            About Us
          </NavLink>

          {/* <NavLink to="/pricing"
            className={({ isActive }) =>
              isActive ? "text-blue-600" : "hover:text-blue-600"
            }
          >
            Pricing
          </NavLink> */}

          <NavLink to="/contact-us"
            className={({ isActive }) =>
              isActive ? "text-blue-600" : "hover:text-blue-600"
            }
          >
            Contact Us
          </NavLink>

          {/* AUTH SECTION */}
          {!isLoggedIn ? (
            <>
              <NavLink
                to="/login"
                className={({ isActive }) =>
                  isActive ? "text-blue-600" : "hover:text-blue-600"
                }
              >
                Login
              </NavLink>

              <NavLink
                to="/register"
                className={({ isActive }) =>
                  isActive ? "text-blue-600" : "hover:text-blue-600"
                }
              >
                Register
              </NavLink>
            </>
          ) : (
            <>

              <NavLink to="/convert-text-2-sql"
                className={({ isActive }) =>
                  isActive ? "text-blue-600" : "hover:text-blue-600"
                }
              >
                Text → SQL
              </NavLink>

              <NavLink to="/convert-sql-2-text"
                className={({ isActive }) =>
                  isActive ? "text-blue-600" : "hover:text-blue-600"
                }
              >
                SQL → Text
              </NavLink>

              {/* <NavLink
                to="/query-history"
                className={({ isActive }) =>
                  isActive ? "text-blue-600" : "hover:text-blue-600"
                }
              >
                Query History
              </NavLink> */}
              <NavLink
                to="/profile"
                className={({ isActive }) =>
                  isActive ? "text-blue-600" : "hover:text-blue-600"
                }
              >
                Profile
              </NavLink>

              <button
                onClick={handleLogout}
                className="text-red-600 hover:text-red-700 ml-4"
              >
                Logout
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
